import {HttpResponse} from "@angular/common/http";

export class MultipartUtils {
    public static parseMultipart(response: HttpResponse<ArrayBuffer>): ArrayBuffer[] {
        const boundary = this.getBoundary(response);
        const boundaryBytes = new TextEncoder().encode(`--${boundary}`);
        const responseBytes = new Uint8Array(response.body);

        let start = 0;
        let parts: ArrayBuffer[] = [];

        for (let i = 0; i < responseBytes.length; i++) {
            if (this.isBoundary(responseBytes, i, boundaryBytes)) {
                if (i > start) {
                    // Extract part between start and boundary
                    const part = responseBytes.slice(start, i).buffer;
                    parts.push(part);
                }
                start = i + boundaryBytes.length;
            }
        }

        // Handle final part
        if (start < responseBytes.length) {
            parts.push(responseBytes.slice(start).buffer);
        }

        parts = parts.filter(value => value?.byteLength > 10);
        // console.log(['parts', parts]);
        return parts;
    }

    public static readJsonFromPart(part: ArrayBuffer): any {
        const decoder = new TextDecoder('utf-8');
        const rawString = decoder.decode(part);
        const jsonStartIndex = rawString.indexOf('\r\n\r\n') + 4; // Trouve la fin des en-têtes
        const jsonString = rawString.substring(jsonStartIndex).trim();
        return JSON.parse(jsonString);
    }


    public static readBlobFromPart(part: ArrayBuffer, mimeType = 'application/octet-stream'): Blob {
        const uint8Array = new Uint8Array(part);
        // Chercher la séquence 0x0D 0x0A 0x0D 0x0A
        let binaryStartIndex = -1;
        for (let i = 0; i < uint8Array.length - 3; i++) {
            if (uint8Array[i] === 13 &&
                uint8Array[i + 1] === 10 &&
                uint8Array[i + 2] === 13 &&
                uint8Array[i + 3] === 10) {
                binaryStartIndex = i + 4;
                break;
            }
        }
        if (binaryStartIndex === -1) {
            throw new Error('Impossible de localiser les en-têtes dans la partie binaire.');
        }

        // Pour extraire le Content-Length, vous pouvez toujours décoder la partie en-tête
        const headerText = new TextDecoder('utf-8').decode(part.slice(0, binaryStartIndex));
        const match = headerText.match(/Content-Length:\s*(\d+)/);
        if (!match) {
            throw new Error('No content length');
        }
        const contentLength = parseInt(match[1], 10);

        // Découper exactement le nombre d'octets indiqué par Content-Length
        const binaryContent = part.slice(binaryStartIndex, binaryStartIndex + contentLength);

        return new Blob([binaryContent], { type: mimeType });
    }

    private static getBoundary(response: HttpResponse<ArrayBuffer>): string {
        const contentType = response.headers.get('Content-Type');
        // console.log(contentType);
        if (!contentType || !contentType.includes('boundary=')) {
            throw new Error('Boundary not found in response Content-Type header');
        }

        // Split parts
        return contentType.split('boundary=')[1]
    }

    private static isBoundary(buffer: Uint8Array, position: number, boundary: Uint8Array): boolean {
        for (let j = 0; j < boundary.length; j++) {
            if (buffer[position + j] !== boundary[j]) {
                return false;
            }
        }
        return true;
    }
}